import Highlighter from 'react-highlight-words'
import { Breadcrumb } from '@winnin/winnin_ui.components.breadcrumb'

import { RCTooltip } from 'components/RCTooltip'
import TerritoryAddToCheckbox from 'components/TerritoryAddToCheckbox'

import type { ITerritoryTitleTableCellView } from './territory-title-table-cell.types'
import './territory-title-table-cell.styles.scss'

export const TerritoryTableCellView = ({
  index,
  entityType,
  id,
  addToItem,
  highlightText,
  name,
  breadcrumbItems,
}: ITerritoryTitleTableCellView) => {
  return (
    <div className="TableTitleWithCheckbox">
      <div className="TableTitleWithCheckbox-checkboxContainer">
        <div className="TableTitleWithCheckbox-index">{index}</div>
        <TerritoryAddToCheckbox entityType={entityType} id={id} entityObject={addToItem} />
      </div>
      <div className="TitleTableCell">
        <RCTooltip tooltipMessage={name}>
          <p>
            {highlightText ? (
              <Highlighter
                highlightClassName="TableTitleWithCheckbox-textHighlight"
                searchWords={[highlightText]}
                autoEscape={true}
                textToHighlight={name}
              />
            ) : (
              name
            )}
          </p>
        </RCTooltip>
        {!!breadcrumbItems?.length && (
          <div className="TitleTableCell-breadcrumb">
            <Breadcrumb items={breadcrumbItems} variation="small" />
          </div>
        )}
      </div>
    </div>
  )
}
